/**
 * Composant d'affichage des résultats du quiz
 * Récupère les données du cookie et affiche le score final
 */
import { useEffect, useState } from 'react';
import { getCookie } from '../utils/cookieUtils';
import '../styles/quiz.css';
import {BoutonAct} from "../components/BoutonAct";

/**
 * Formate le temps en secondes au format MM:SS
 * @param {number} seconds - Nombre de secondes
 * @returns {string} Temps formaté
 */
const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
};

/**
 * QuizResults - Affiche les résultats finaux du quiz
 * @param {Object} props - Les propriétés du composant
 * @param {function} props.onRestart - Fonction appelée pour recommencer un quiz
 * @param {function} props.onExit - Fonction appelée pour retourner aux catégories
 * @returns {JSX.Element} Écran de résultats du quiz
 */
export function QuizResults({ onRestart, onExit }) {
    const [scoreData, setScoreData] = useState(null);
    const categorie=getCookie('lastSelectedCategory');

    useEffect(() => {
        // Récupère les données du score depuis le cookie
        const scoreJson = getCookie('quizLastScore');
        if (scoreJson) {
            try {
                const data = JSON.parse(scoreJson);
                setScoreData(data);
            } catch (error) {
                console.error('Erreur lors de la lecture du cookie:', error);
            }
        }
    }, []);

    if (!scoreData) {
        return (
            <div className="quiz-container">
                <div className="quiz-error">
                    <p>Résultats indisponibles</p>
                    <button onClick={onExit} className="btn-exit">Retour aux catégories</button>
                </div>
            </div>
        );
    }

    return (
        <div className="quiz-container">
            <div className="quiz-results1" data-category={categorie}>
                <div>
                    <h1 className="results-title">Quiz terminé !</h1>
                    <p>{categorie}</p>
                </div>

                <div className="trophee">
                    <img src="/trophee.png" alt="Trophée" />
                </div>

                <div className="results">
                    <div className="results-info">
                        <p className="info-value">{scoreData.score*100}</p>
                        <p className="info-title">Points</p>
                    </div>
                    <div className="results-info">
                        <p className="info-value">{formatTime(scoreData.totalTime)}</p>
                        <p className="info-title">Temps</p>
                    </div>
                </div>
            </div>
            <div className="coupole" data-category={categorie}></div>

            <div className="quiz-results2">
                <div className="quiz-results2-detail">
                    <div className="quiz-results2-detail-div">
                        <p className="info-title">Ancien record</p>
                        <p className="info-value">x pts</p>
                    </div>
                    <div className="quiz-results2-detail-div">
                        <p className="info-title">Nouveau score</p>
                        <p className="info-value">{scoreData.score*100} pts</p>
                    </div>
                    <div className="quiz-results2-detail-div">
                        <p className="info-title">Bonne réponse</p>
                        <p className="info-value">{scoreData.score}/{scoreData.totalQuestions}</p>
                    </div>
                    <div className="quiz-results2-detail-div">
                        <p className="info-title">Accomplissement</p>
                        <p className="info-value">{scoreData.percentage}%</p>
                    </div>
                </div>
                <div className="results-actions">
                    <button onClick={onRestart}>
                        <BoutonAct
                            contenu="Recommencer"
                            categorie={categorie}/>
                    </button>
                    <button onClick={onExit}>
                        <BoutonAct
                            contenu="quitter"/>
                    </button>
                </div>
            </div>
        </div>
    );
}
